import { memo, useEffect } from 'react';
import { InfinityList } from '@widgets/shared/InfinityList/index.tsx';
import { SkeletonList } from '@shared/ui/skeleton-list/index.ts';
import { EventCard } from '@src/library/components/events';
import { Blank, Loader } from 'library/components/common';
import { useEvenList } from './model';
import * as st from './styles.module.scss';

interface Props {
  api: string;
  params: {
    search?: string;
    tags?: number[];
    authors?: number[];
    module?: number;
    [x: string]: any;
  };
  setTitles?: (titles: string[]) => void;
  setAuthors?: (authors: number[]) => void;
  setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const EventList = memo(({ api, params, setTitles, setAuthors, setLoading }: Props) => {
  const { ids, hasMore, getEvents, titles, authors, status, events, setEvents, isLoading } =
    useEvenList(api, params);

  useEffect(() => {
    setLoading && setLoading(isLoading);
    setTitles && setTitles(titles);
    setAuthors && setAuthors(authors);
  }, [titles, authors, isLoading, setLoading]);

  const deleteEventFromList = (id: number) => {
    const updateEvents = events.filter((event) => event.id !== id);
    setEvents(updateEvents);
  };
  if (status === 'fetching') {
    return <SkeletonList />;
  }
  return (
    <>
      <section className={st.list}>
        <InfinityList
          hasMore={hasMore}
          loadMore={getEvents}
          loading={status === 'loading'}
          className={st.scroller}
        >
          <ul className={st.listCards}>
            {events.map((event) => (
              <li key={event.id}>
                <EventCard event={event} onDelete={deleteEventFromList} />
              </li>
            ))}
          </ul>

          <div className={st.loader}>
            {!hasMore && !ids.length && (
              <Blank
                text={
                  params.search || params.tags?.length
                    ? 'По вашему запросу ничего не найдено'
                    : 'Нет мероприятий'
                }
              />
            )}
            {status === 'loading' && <Loader />}
          </div>
        </InfinityList>
      </section>
    </>
  );
});
